import { forwardRef, type PropsWithChildren, useId } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { ProgressBarProps } from "./ProgressBar.types";

const ProgressBar = forwardRef<
  HTMLDivElement,
  PropsWithChildren<ProgressBarProps>
>(
  (
    { value, className, progressClassName, ...progressBarProps },
    forwardedRef,
  ) => {
    const labelId = useId();

    if (value < 0 || value > 100) {
      console.warn(
        `ProgressBar value should be between 0 and 100, received ${value}`,
      );
    }

    return (
      <div
        ref={forwardedRef}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={value}
        aria-labelledby={labelId}
        className={cn(
          "relative h-4 w-full overflow-hidden rounded-pill bg-neutral-200",
          className,
        )}
        {...progressBarProps}
      >
        <div
          className={cn(
            "relative left-0 h-full rounded-pill bg-primary",
            progressClassName,
          )}
          style={{
            width: `${value}%`,
            transition: "width 0.3s ease-out",
          }}
        />
        <span id={labelId} className="sr-only">
          Progress: {value}%
        </span>
      </div>
    );
  },
);

ProgressBar.displayName = "ProgressBar";

export default ProgressBar;
